import React from 'react';
import * as ChessUtils from './ChessUtils.js';
import ChessBoard from './ChessBoard.js';
import Settings from './Settings.js';

// Require Editor CSS files.
//import 'froala-editor/css/froala_style.min.css';
//import 'froala-editor/css/froala_editor.pkgd.min.css';

import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';

import Modal from 'react-modal';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import {RadioGroup, Radio} from 'react-radio-group'
import domtoimage from 'dom-to-image';

import ReactSelect from 'react-select';

//import 'react-notifications/lib/notifications.css';

import $ from 'jquery';
//var $ = window.$;
const { firebase } = window;

const ChessboardjsThemes = require('./chessboardjs-themes.js');
const location = require('./Localization.js');
const strings = location.default;
strings.setLanguage('hu');

const md5 = require('js-md5');
const { jQuery } = window;
const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR";
const availablePieceThemes = {
    'wikipedia': {
        name: 'Wikipedia PNG',
        pieceTheme: '/chessboardjs/img/chesspieces/wikipedia/{piece}.png'
    },
    'wikipedia-svg': {
        name: 'Wikipedia SVG',
        pieceTheme: '/chessboardjs/img/chesspieces/wikipedia-svg/{piece}.svg'
    },
    'wikipedia-svg-color': {
        name: 'Wikipedia SVG color',
        pieceTheme: function pieceTheme(piece) {
            // wikipedia theme for white pieces
            if (piece.search(/w/) !== -1) {
                return '/chessboardjs/img/chesspieces/wikipedia-svg-color/' + piece.replace('w', 'r') + '.svg';
            }

            // alpha theme for black pieces
            return '/chessboardjs/img/chesspieces/wikipedia-svg-color/' + piece.replace('b', 'g') + '.svg';
        }
        
    },
    'wikipedia-svg-playful': {
        name: 'Wikipedia SVG playful',
        pieceTheme: '/chessboardjs/img/chesspieces/wikipedia-svg-playful/{piece}.svg'
    },
    'alpha': {
        name: 'Alpha',
        pieceTheme: ChessboardjsThemes.getPieceTheme('alpha_piece_theme')
    },
    'chess24': {
        name: 'Chess 24',
        pieceTheme: ChessboardjsThemes.getPieceTheme('chess24_piece_theme')
    },
    'dilena': {
        name: 'Dilena',
        pieceTheme: ChessboardjsThemes.getPieceTheme('dilena_piece_theme')
    },
    'leipzig': {
        name: 'Leipzig',
        pieceTheme: ChessboardjsThemes.getPieceTheme('leipzig_piece_theme')
    },
    'metro': {
        name: 'Metro',
        pieceTheme: ChessboardjsThemes.getPieceTheme('metro_piece_theme')
    },
    'symbol': {
        name: 'Symbol',
        pieceTheme: ChessboardjsThemes.getPieceTheme('symbol_piece_theme')
    },
    'uscf': {
        name: 'Uscf',
        pieceTheme: ChessboardjsThemes.getPieceTheme('uscf_piece_theme')
    },
    'colorful': {
        name: 'Colorful',
        pieceTheme: '/chessboardjs/img/chesspieces/colorful/{piece}.png'
    },
    'playful': {
        name: 'Playful',
        pieceTheme: '/chessboardjs/img/chesspieces/playful/{piece}.png'
    },
    'cartoon1': {
        name: 'Cartoon 1',
        pieceTheme: '/chessboardjs/img/chesspieces/cartoon1/{piece}.png'
    },
    'cartoon2': {
        name: 'Cartoon 2',
        pieceTheme: '/chessboardjs/img/chesspieces/cartoon2/{piece}.png'
    },
    'cartoon3': {
        name: 'Cartoon 3',
        pieceTheme: '/chessboardjs/img/chesspieces/cartoon3/{piece}.png'
    },
    
}
const availableBoardThemes = {
    book: {
        white: '#f0d9b5',
        black: '#b58863',
    },
    chess24: {
        white: '#9E7863',
        black: '#633526',
    },
    wikipedia: {
        white: '#D18B47',
        black: '#FFCE9E',
    },
    workbook1: {
        white: '#ffffff',
        black: '#dcdcdc',
    },
    workbook2: {
        white: '#ffffff',
        black: '#d3d3d3',
    },
    workbook3: {
        white: '#ffffff',
        black: '#c0c0c0',
    },
    workbook4: {
        white: '#ffffff',
        black: '#a9a9a9',
    },
    workbook5: {
        white: '#ffffff',
        black: '#808080',
    },
    custom: {}
}
const availableFontFamilys = {
    'Abel': { family: "'Abel', sans-serif" },
    'Aladin': { family: "'Aladin', cursive" },
    'Aldrich': { family: "'Aldrich', sans-serif" },
    'Anton': { family: "'Anton', sans-serif" },
    'Arimo': { family: "'Arimo', sans-serif" },
    'Arvo': { family: "'Arvo', serif" },
    'Bitter': { family: "'Bitter', serif" },
    'Cabin': { family: "'Cabin', sans-serif" },
    'Crimson Text': { family: "'Crimson Text', serif" },
    'Dosis': { family: "'Dosis', sans-serif" },
    'Exo 2': { family: "'Exo 2', sans-serif" },
    'Fira Sans': { family: "'Fira Sans', sans-serif" },
    'Hind': { family: "'Hind', sans-serif" },
    'Inconsolata': { family: "'Inconsolata', monospace" },
    'Indie Flower': { family: "'Indie Flower', cursive" },
    'Josefin Sans': { family: "'Josefin Sans', sans-serif" },
    'Karla': { family: "'Karla', sans-serif" },
    'Lato': { family: "'Lato', sans-serif" },
    'Libre Baskerville': { family: "'Libre Baskerville', serif" },
    'Libre Franklin': { family: "'Libre Franklin', sans-serif" },
    'Lobster': { family: "'Lobster', cursive" },
    'Lora': { family: "'Lora', serif" },
    'Merriweather Sans': { family: "'Merriweather Sans', sans-serif" },
    'Montserrat': { family: "'Montserrat', sans-serif" },
    'Muli': { family: "'Muli', sans-serif" },
    'Noto Sans': { family: "'Noto Sans', sans-serif" },
    'Noto Serif': { family: "'Noto Serif', serif" },
    'Nunito': { family: "'Nunito', sans-serif" },
    'Open Sans': { family: "'Open Sans', sans-serif" },
    'Oswald': { family: "'Oswald', sans-serif" },
    'Oxygen': { family: "'Oxygen', sans-serif" },
    'Pacifico': { family: "'Pacifico', cursive" },
    'Playfair Display': { family: "'Playfair Display', serif" },
    'Poppins': { family: "'Poppins', sans-serif" },
    'PT Sans': { family: "'PT Sans', sans-serif" },
    'PT Sans Narrow' : { family: "'PT Sans Narrow', sans-serif" },
    'PT Serif': { family: "'PT Serif', serif" },
    'Quicksand': { family: "'Quicksand', sans-serif" },
    'Raleway': { family: "'Raleway', sans-serif" },
    'Roboto': { family: "'Roboto', sans-serif" },
    'Roboto Condensed': { family: "'Roboto Condensed', sans-serif" },
    'Roboto Mono': { family: "'Roboto Mono', monospace" },
    'Roboto Slab': { family: "'Roboto Slab', serif" },
    'Rubik': { family: "'Rubik', sans-serif" },
    'Slabo 27px': { family: "'Slabo 27px', serif" },
    'Source Sans Pro': { family: "'Source Sans Pro', sans-serif" },
    'Titillium Web': { family: "'Titillium Web', sans-serif" },
    'Ubuntu': { family: "'Ubuntu', sans-serif" },
    'Varela Round': { family: "'Varela Round', sans-serif" },
    'Work Sans': { family: "'Work Sans', sans-serif" },
}
const availableCoordinateThemes = {
    black: [
        '/chessboardjs/img/coordinates/black/alma.svg',
        '/chessboardjs/img/coordinates/black/banan.svg',
        '/chessboardjs/img/coordinates/black/cica.svg',
        '/chessboardjs/img/coordinates/black/dinnye.svg',
        '/chessboardjs/img/coordinates/black/elefant.svg',
        '/chessboardjs/img/coordinates/black/fagyi.svg',
        '/chessboardjs/img/coordinates/black/golya.svg',
        '/chessboardjs/img/coordinates/black/haz.svg',
    ],
    color: [
        '/chessboardjs/img/coordinates/color/alma.svg',
        '/chessboardjs/img/coordinates/color/banan.svg',
        '/chessboardjs/img/coordinates/color/cica.svg',
        '/chessboardjs/img/coordinates/color/dinnye.svg',
        '/chessboardjs/img/coordinates/color/elefant.svg',
        '/chessboardjs/img/coordinates/color/fagyi.svg',
        '/chessboardjs/img/coordinates/color/golya.svg',
        '/chessboardjs/img/coordinates/color/haz.svg',        
    ]
}
const whoCanWinStates = [
    {icon: '/chessboardjs/img/chesspieces/wikipedia/wP.png', html: '<div class="arrow-up"><div></div></div>'},
    {icon: '/chessboardjs/img/chesspieces/wikipedia/bP.png', html: '<div class="arrow-down-wrapper"><div class="arrow-down"></div></div>'},
    {icon: '/chessboardjs/img/white_black_win.png', html: '<div class="arrow-up"><div></div></div><div class="arrow-down-wrapper"><div class="arrow-down"></div></div>'},
    {icon: '/chessboardjs/img/none_win.png', html: ''},
]
const gamificationStates = [
    {},
    {icon: '/chessboardjs/img/chesspieces/cartoon2/wK.png', style: {float: 'left', marginRight: '5px', width: '80px'}},
    {icon: '/chessboardjs/img/Santa-figure.png', style: {float: 'left', marginRight: '5px', width: '80px'}},
    {icon: '/chessboardjs/img/Santa-figure2.png', style: {float: 'right', marginLeft: '5px', width: '120px'}},
    {icon: '/chessboardjs/img/Santa-figure3.jpg', style: {float: 'left', marginRight: '5px', width: '80px'}},
]
var difficultyStates = {
    'easy': '/chessboardjs/img/light_icon.png',
    'hard': '/chessboardjs/img/difficult_icon.png',
    'none': '',
    'custom': '',
}
const defaultHeadlineText = '<table style="width: 100%;"><tbody><tr><td style="width: 24.9377%;">#P</td><td style="width: 49.8753%;"><div style="text-align: center;"></div></td><td style="width: 12.5000%;">#D</td><td style="width: 12.5000%;">#W</td></tr></tbody></table>';

const languageFlags = {
    'hu': { value: 'hu', label: <img alt="hu" src="chessboardjs/img/flags/hu.svg" style={{width: 25}} /> },
    'en': { value: 'en', label: <img alt="en" src="chessboardjs/img/flags/gb.svg" style={{width: 25}} /> }
}
var stateVariableName = 'state191113v2';

const defaultState = {
    accountId: '',
    activeEditor: null,
    arrowMode: false,
    arrows: [],
    arrowStyle: {
        arrow1: {
            dash: 0,
            lineColor: '#000000',
            lineSize: 2,
            location: 'over',
            headColor: '#000000',
            headOutlineColor: '#000000',
            headSize: 2,
            opacity: 10,
            type: 'normal',
        },
        arrow2: {
            dash: 0,
            lineColor: '#f00f00',
            lineSize: 2,
            location: 'over',
            headColor: '#f00f00',
            headOutlineColor: '#f00f00',
            headSize: 2,
            opacity: 10,
            type: 'normal',
        },                
        arrow3: {
            dash: 0,
            lineColor: '#0000f0',
            lineSize: 2,
            location: 'over',
            headColor: '#0000f0',
            headOutlineColor: '#0000f0',
            headSize: 2,
            opacity: 10,
            type: 'normal',
        },
    },
    board: {
        draggable: true,
        pieceTheme: 'wikipedia',
        pieceSize: '100%',
        boardPattern: 'no',
        boardTheme: 'book',
        boardColors: availableBoardThemes.book,
        orientation: 'white',
        position: {},
        extraPieceSize: 8,
        boardSize: 8,
    },
    chosenCustomTheme: '',
    chosenPositionCategory: '',
    chosenPositionSubCategory: '',
    customThemeName: '',
    currentArrow: {},
    currentPage: 1,
    defaultTab: 0,
    defaultTabExtra: 0,
    description: {
        text: "",
        gamification: false,
    },
    difficulty: 'easy',
    exportCount: 0,
    exportLayout: '1x1',
    exportLimit: 0,
    exportSize: '',
    exportSizeCustom: '',
    fileList: {},
    headline: {
        text: defaultHeadlineText,
    },
    highLightMode: false,
    highlights: {},
    highlightStyle: {
        highlight1: {
            type: 'square',
            color: '#000000',
            radius: 0,
            size: 3
        },
        highlight2: {
            type: 'square',
            color: '#ff0000',
            radius: 0,
            size: 3
        },
        highlight3: {
            type: 'square',
            color: '#0000ff',
            radius: 0,
            size: 3
        },
    },
    indexMode: false,
    indexes: {},
    indexStyle: {
        index1: {
            type: 'square',
            color: '#000000',
            radius: 0,
            size: 3
        },
        index2: {
            type: 'square',
            color: '#ff0000',
            radius: 0,
            size: 3
        },
        index3: {
            type: 'square',
            color: '#0000ff',
            radius: 0,
            size: 3
        },
    },
    language: 'hu',
    layerMode: false,
    layers: {},
    layerStyle: {
        layer1: {
            backgroundColor: '#000000',
            opacity: 1,
        },
        layer2: {
            backgroundColor: '#ff0000',
            opacity: 1,
        },
        layer3: {
            backgroundColor: '#0000ff',
            opacity: 1,
        },
    },
    localStorage: false,
    modal: {},
    multiAddPiece: false,
    notation: {
        color: '#b58863',
        fontFamily: 'Open Sans',
        fontSize: 20,
        fontStyle: 'normal',
        type: 'color',
    },
    password: '',
    rerender: 0,
    showBoard: false,
    showSettings: true,
    userId: '',
    wallMode: false,
    walls: {},
    wallStyle: {
        wall1: {
            style: 'solid',
            size: 1,
            color: '#000000',
        },
        wall2: {
            style: 'solid',
            size: 1,
            color: '#ff0000',
        },
        wall3: {
            style: 'solid',
            size: 1,
            color: '#0000ff',
        },
    },
    watermark: true,
    whoCanWin: 0,            
}

Modal.setAppElement('#root');

var customThemeList = {};
var positionCategoriesByParent = {}, positionCategoryObj = {}, positionCategoryList = [];
var positionList = {}, positionObj = {};
var printableBoards = [], printablePositions = [];
var undoMode = false, originalBoard;

export default class Game extends React.Component {
    constructor(props) {
        super(props);

        stateVariableName += this.props.location.pathname;
        let localStorageState = this.getLocalstorageState();

        defaultState.accountId = this.getAccountId() ? this.getAccountId() : '';
        this.state = Object.assign(defaultState, localStorageState);
        
        document.onkeydown = (evt) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                this.cancelFeature();
            }

            /*if (evt.keyCode === 90 && evt.ctrlKey) {
                console.log('CTRL+Z');
                this.undoHistory();
            } */
            // Vmiért bugos az undo majd redo, elég csak az undo
            /*if (evt.keyCode === 89 && evt.ctrlKey) {
                console.log('CTRL+Y');
                this.redoHistory();
            }*/
        };

        this.fen = React.createRef();
        this.position_name = React.createRef();
        this.category_name = React.createRef();
        this.category_parent = React.createRef();
        this.exportable_positions = React.createRef();
    }

    render() {
        console.log('STATE', this.state);

        if (!this.state.showBoard && !this.state.localStorage) {
            
            return this.getAccountId()
                ? (
                    <div>
                        <form style={{width: "400px"}}>
                        <fieldset>
                        <label>{strings.username}:</label>
                        <input type="text" name="input" onChange={(e) => this.setState({userId: e.target.value})} value={this.state.userId} />
                        <label>{strings.password}:</label>
                        <input type="password" name="password" onChange={(e) => this.setState({password: e.target.value})} value={this.state.password} />
                        <button onClick={this.loadAccount.bind(this)}>{strings.login}</button>
                        </fieldset>
                        </form>
                        <NotificationContainer/>
                    </div>
                )
                : (
                    <div>
                        <form style={{width: "400px"}}>
                        <fieldset>
                        <label>{strings.account}:</label>
                        <input type="text" name="input" onChange={(e) => this.setState({accountId: e.target.value})} value={this.state.accountId} />
                        <button onClick={this.loadAccount.bind(this)}>{strings.login}</button>
                        </fieldset>
                        </form>
                        <NotificationContainer/>
                    </div>
                )
        } else if (!this.state.showBoard && this.state.localStorage) {
            return (
                <div></div>
            )
        }

        var boardStyle = this.state.notation.type !== 'none'
            ? {paddingBottom: '50px'}
            : {paddingBottom: '5px'};

        var watermark = this.state.watermark
            ? (
                <div className="watermark">
                    <div className="watermark-text">{strings.watermarkText}</div>
                </div>
            )
            : ''

        var chessboard = null;
        if (this.state.showBoard) {
            chessboard = (
                <ChessBoard
                accountId={this.state.accountId}
                arrowMode={this.state.arrowMode}
                arrows={this.state.arrows}
                arrowStyle={this.state.arrowStyle}
                availableCoordinateThemes={availableCoordinateThemes}
                availableFontFamilys={availableFontFamilys}
                board={this.state.board}
                boardStyle={boardStyle}
                boardWidth="400"
                dblClickOnSquare={this.dblClickOnSquare.bind(this)}
                draggable={this.state.board.draggable}
                dropOffBoard="trash"
                enableMultiAddMode={this.enableMultiAddMode.bind(this)}
                highLightMode={this.state.highLightMode}
                highlights={this.state.highlights}
                highlightStyle={this.state.highlightStyle}
                indexMode={this.state.indexMode}
                indexes={this.state.indexes}
                indexStyle={this.state.indexStyle}
                layerMode={this.state.layerMode}
                layers={this.state.layers}
                layerStyle={this.state.layerStyle}
                multiAddPiece={this.state.multiAddPiece}
                notation={this.state.notation}
                onClickSquare={this.onClickSquare.bind(this)}
                onMouseoutSquare={this.onMouseoutSquare.bind(this)}
                onMouseoverSquare={this.onMouseoverSquare.bind(this)}
                onMouseDownSquare={this.onMouseDownSquare.bind(this)}
                onMouseUpSquare={this.onMouseUpSquare.bind(this)}
                pieceTheme={availablePieceThemes[this.state.board.pieceTheme].pieceTheme}
                removeArrow={this.removeArrow.bind(this)}
                showNotation={true}
                previewIndex={this.previewIndex.bind(this)}
                previewWall={this.previewWall.bind(this)}
                sparePieces={true}
                strings={strings}
                updatePosition={this.updatePosition.bind(this)}
                wallMode={this.state.wallMode}
                walls={this.state.walls}
                wallStyle={this.state.wallStyle}
                watermark={watermark}
                />
            );    
        }

        var headlineStyle = {
            width: '396px'
        };
        var descriptionStyle = {
            textAlign: 'left',
            fontSize: '20px'
        };

        var gameFigureTop, gameFigureBottom;
        /*if (this.state.headline.gamification) {
            gameFigureTop = <img src="/chessboardjs/img/chesspieces/cartoon2/wP.png" style={{position: 'absolute', float: 'right', left: '365px', top: '0px'}} />;
            headlineStyle.marginRight = '50px';
        }*/
        if (this.state.description.gamification && gamificationStates[this.state.description.gamification]) {
            gameFigureBottom = <img alt="" src={gamificationStates[this.state.description.gamification].icon} style={gamificationStates[this.state.description.gamification].style} />;
            descriptionStyle.minHeight = '105px';
            if (this.state.notation.type !== 'none' && gamificationStates[this.state.description.gamification].style.float === 'left') {
                descriptionStyle.marginLeft = '-35px';
                descriptionStyle.marginRight = '52px';
            }
        }
        var cursor_image;
        if (this.state.multiAddPiece) {
            var cursor_image_src;
            if (this.state.multiAddPiece.figure[0] !== "e") {
                cursor_image_src = availablePieceThemes.wikipedia.pieceTheme.replace(/{piece}/g, this.state.multiAddPiece.figure)
            } else {
                cursor_image_src = this.state.multiAddPiece.url;
            }
            cursor_image = <img alt="" id="cursor_image" style={{width: '25px', height: '25px', position: 'absolute', zIndex: 10000, display: 'none'}} src={cursor_image_src} />;
        }
        
        var boardsContainerStyle = { background: "#fff" };
        var boardPrintStyle = {height: "auto", background: "#fff", textAlign: "center"};
        if (this.state.notation.type !== 'none') {
            boardPrintStyle.padding = "10px 1rem 0px 40px";
            boardPrintStyle.width = "450px";
            boardsContainerStyle.width = "450px";
        } else {
            boardPrintStyle.padding = "10px 20px 0px 20px";
            boardPrintStyle.width = "435px";
            boardsContainerStyle.width = "435px";
        }

        if (this.state.customDifficulty) {
            difficultyStates.custom = this.state.customDifficulty;
        }
        var difficultyHtml;
        if (difficultyStates[this.state.difficulty]) {
            difficultyHtml = '<div class="difficulty_wrapper"><div class="difficulty_div"><img alt="" src="'+difficultyStates[this.state.difficulty]+'" /></div></div>';
        } else {
            difficultyHtml = '';
        }

        var headLineText = this.state.headline.text;

        headLineText = headLineText.replace(/#P/g, '<div class="position_number">'+this.state.currentPage+'</div>');
        headLineText = headLineText.replace(/#W/g, whoCanWinStates[this.state.whoCanWin].html);
        headLineText = headLineText.replace(/#D/g, difficultyHtml);
        headLineText = headLineText.replace(/<br>/g, '');

        const modalStyles = {
            content : {
              top                   : '50%',
              left                  : '50%',
              right                 : 'auto',
              bottom                : 'auto',
              marginRight           : '-50%',
              transform             : 'translate(-50%, -50%)',
              zIndex                : 10000,
              minWidth              : '400px'
            }
        };

        const categorySelectHtml = (
            <div className="column" style={{width: '280px'}}>
                <select
                id="categorySelect"
                value={this.state.chosenPositionCategory}
                onChange={(e) => this.setState({chosenPositionCategory: e.target.value, chosenPositionSubCategory: ''})}
                >
                    <option value="">{strings.chooseCategory}</option>
                    {
                        positionCategoryList.filter(item => item.parent === '#root')
                        .map(item => <option key={item.id} value={item.id}>{item.name}</option>)
                    }
                </select>
            </div>
        );

        const subCategorySelectHtml = (
            <div className="column" style={{width: '280px'}}>
                <select
                id="subcategorySelect"
                value={this.state.chosenPositionSubCategory}
                onChange={(e) => this.setState({chosenPositionSubCategory: e.target.value})}
                disabled={this.state.chosenPositionCategory?false:true}
                >
                    <option value="">{strings.chooseSubcategory}</option>
                    {
                        positionCategoryList
                        .filter(item => item.parent === this.state.chosenPositionCategory)
                        .map(item => <option key={item.id} value={item.id}>{item.name}</option>)
                    }
                </select>
            </div>
        )

        return (
            <div className="container">
                <div className="top_menu">
                    <div className="row">
                        <div className="column username_div">
                            {strings.username}: {this.state.userId} <a href="#" onClick={this.logOut.bind(this)}>{strings.logout}</a>
                        </div>
                        <div className="column">
                            {this.state.accountId !== '1' ?
                            (
                                <div className="export_counter">
                                    {strings.remainingCredits}: <b>{this.state.exportLimit-this.state.exportCount} / {this.state.exportLimit}</b>
                                    {/*&nbsp;<button className="buy_credits"></button>*/}
                                </div>
                            ) : (
                                <div className="export_counter"></div>
                            )}
                        </div>
                        <div className="column language_selecter">
                            <ReactSelect
                                value={languageFlags[this.state.language]}
                                onChange={this.changeLanguage.bind(this)}
                                options={Object.values(languageFlags)}
                                styles={{
                                    menu: (provided, state) => ({
                                        ...provided,
                                        width: 50,
                                        padding: 0
                                    }),
                                    control: (provided, state) => ({
                                        ...provided,
                                        height: 20,
                                        width: 90,
                                        padding: 0,
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="column boardColumn">
                        <div id="boardsContainer" style={boardsContainerStyle}>
                            {(this.state.showBoard) ? 
                            (
                                <div className="boardPrint" style={boardPrintStyle}>
                                <div id="headline" style={headlineStyle}>
                                    {gameFigureTop}
                                    <FroalaEditorView model={headLineText} />
                                </div>
                                {cursor_image}
                                {chessboard}
                                <div>
                                </div>
                                <div style={descriptionStyle}>
                                    {gameFigureBottom}
                                    <FroalaEditorView model={this.state.description.text} />
                                </div>
                            </div>
                            ) : ''}
                        </div>
                        {/*<p>Canvas:</p>
                        <canvas id="myCanvas" style={{border: '1px solid #d3d3d3'}}>
                        Your browser does not support the HTML5 canvas tag.
                        </canvas>*/}
                    </div>
                    <div id="actionbuttons" className="column">
                        <table className="actionButtons"><tbody>
                        <tr>
                            <td><img alt={strings.undo} title={strings.undo} onClick={this.undoHistory.bind(this)} src="/chessboardjs/img/icons/undo-history.svg" /></td>
                            <td><img alt={strings.redo} title={strings.redo} onClick={this.redoHistory.bind(this)} src="/chessboardjs/img/icons/redo-history.svg" /></td>
                        </tr>
                        <tr>
                            <td><img alt={strings.startPosition} title={strings.startPosition} onClick={this.startPosition.bind(this)} src="/chessboardjs/img/icons/start-position.svg" /></td>
                            <td><img alt={strings.clearBoard} title={strings.clearBoard} onClick={this.clearBoard.bind(this)} src="/chessboardjs/img/icons/clear-board.svg" /></td>
                            <td><img alt={strings.flipBoard} title={strings.flipBoard} onClick={this.flipBoard.bind(this)} src="/chessboardjs/img/icons/flip-board.svg" /></td>
                        </tr>
                        {this.getExtra('highlight')}
                        {this.getExtra('arrow')}
                        {this.getExtra('wall')}
                        {this.getExtra('layer')}
                        {this.getExtra('index')}
                        <tr>
                            <td><img alt={strings.savePosition} title={strings.savePosition} onClick={this.toggleModal.bind(this, 'save_pos')} src="/chessboardjs/img/icons/save-position.png" /></td>
                            <td><img alt={strings.loadPosition} title={strings.loadPosition} onClick={this.toggleModal.bind(this, 'load_pos')} src="/chessboardjs/img/icons/load-position.png" /></td>
                            <td><img alt={strings.newPosition} title={strings.newPosition} onClick={this.newPosition.bind(this)} src="/chessboardjs/img/icons/new-position.png" /></td>
                        </tr>
                        <tr>
                            <td><img alt={strings.exportBoard} title={strings.exportBoard} onClick={this.toggleModal.bind(this, 'export_board')} src="/chessboardjs/img/icons/export-board.svg" /></td>
                            <td><img alt={strings.exportAllPositions} title={strings.exportAllPositions} onClick={this.toggleModal.bind(this, 'export_all')} src="/chessboardjs/img/icons/export-board.svg" /></td>
                            <td><img alt={strings.shareSettings} title={strings.shareSettings} onClick={this.shareSettings.bind(this)} src="/chessboardjs/img/icons/share-settings.svg" /></td>
                        </tr>
                        </tbody></table>
                        
                        <div>
                            <Modal
                            isOpen={this.state.modal.save_theme}
                            onAfterOpen={this.afterOpenModal.bind(this, 'save_theme')}
                            onRequestClose={this.toggleModal.bind(this, 'save_theme')}
                            style={modalStyles}
                            >
                            <h2>{strings.saveTheme}</h2>
                            <div>{strings.themeName}</div>
                            <form>
                                <input type="text" name="customThemeName" value={this.state.customThemeName} onChange={(e) => this.setState({customThemeName: e.target.value})} />
                                <button onClick={this.saveTheme.bind(this)}>{strings.save}</button>&nbsp;
                                <button onClick={this.toggleModal.bind(this, 'save_theme')}>{strings.cancel}</button>
                            </form>
                            </Modal>
                            <Modal
                            isOpen={this.state.modal.load_theme}
                            onAfterOpen={this.afterOpenModal.bind(this, 'load_theme')}
                            onRequestClose={this.toggleModal.bind(this, 'load_theme')}
                            style={modalStyles}
                            >
                            <h2>{strings.loadTheme}</h2>
                            <div>{strings.themeName}</div>
                            <form>
                                <select
                                id="customThemeList"
                                value={this.state.chosenCustomTheme}
                                onChange={(e) => this.setState({chosenCustomTheme: e.target.value})}
                                style={{width: '250px'}}
                                >
                                    <option key="0" value="">--- {strings.chooseTheme} ---</option>
                                    {Object.keys(customThemeList).map(name => <option key={name} value={name}>{name}</option>)}
                                </select>
                                <div>
                                <button onClick={this.loadTheme.bind(this)}>{strings.load}</button>&nbsp;
                                <button onClick={this.toggleModal.bind(this, 'load_theme')}>{strings.cancel}</button>
                                </div>
                            </form>
                            </Modal>

                            <Modal
                            isOpen={this.state.modal.save_pos}
                            onAfterOpen={this.afterOpenModal.bind(this, 'save_pos')}
                            onRequestClose={() => { this.setState({selectedPosition: ''}); this.toggleModal('save_pos'); if (this.state.selectedPosition) { this.toggleModal('load_pos'); } }}
                            style={modalStyles}
                            >
                            <h2>{this.state.selectedPosition ? strings.editPosition : strings.savePosition}</h2>
                            <form>
                                {this.state.selectedPosition
                                    ? ''
                                    : <div><a href="" onClick={(e) => { e.preventDefault(); this.toggleModal('edit_categories'); }}>{strings.editCategories}</a></div>
                                }
                                <label htmlFor="categorySelect">{strings.category}</label>
                                <div className="row">
                                    {categorySelectHtml}
                                    <div className="column" style={{width: '50px'}}>
                                        <div onClick={this.toggleModal.bind(this, 'add_category')} className="addButton">+</div>
                                    </div>
                                </div>
                                <div style={!this.state.chosenPositionCategory ? {display: 'none'}: {}}>
                                <label htmlFor="subcategorySelect">{strings.subcategory}</label>
                                <div className="row">
                                    {subCategorySelectHtml}
                                    <div className="column" style={{width: '50px'}}>
                                        <div onClick={this.toggleModal.bind(this, 'add_subcategory')} className="addButton">+</div>
                                    </div>
                                </div>
                                </div>

                                <div style={this.state.chosenPositionCategory && this.state.chosenPositionSubCategory ? {} : {display: 'none'}}>
                                    <label htmlFor="positionName">{strings.positionName}</label>
                                    <input ref={this.position_name} id="positionName" type="text" name="position_name" defaultValue={(this.state.selectedPosition && positionObj[this.state.selectedPosition]) ? positionObj[this.state.selectedPosition].name : ''} />
                                    <div>
                                    <button onClick={this.savePosition.bind(this)}>{strings.save}</button>&nbsp;
                                    <button onClick={() => { this.setState({selectedPosition: ''}); this.toggleModal('save_pos'); if (this.state.selectedPosition) { this.toggleModal('load_pos'); } }}>{strings.cancel}</button>
                                    </div>
                                </div>
                            </form>
                            </Modal>

                            <Modal
                            isOpen={this.state.modal.load_pos}
                            onAfterOpen={this.afterOpenModal.bind(this, 'load_pos')}
                            onRequestClose={this.toggleModal.bind(this, 'load_pos')}
                            style={modalStyles}
                            >
                            <h2>{strings.loadPosition}</h2>
                            <form>
                                <label htmlFor="categorySelect">{strings.category}</label>
                                <div className="row">
                                    {categorySelectHtml}
                                </div>
                                <div style={!this.state.chosenPositionCategory ? {display: 'none'}: {}}>
                                <label htmlFor="subcategorySelect">{strings.subcategory}</label>
                                <div className="row">
                                    {subCategorySelectHtml}    
                                </div>
                                </div>

                                <div style={!this.state.chosenPositionSubCategory ? {display: 'none'}: {}}>
                                    <div style={{float: 'left'}}>
                                    <label htmlFor="positionName">{strings.choosePosition}</label>
                                    <select ref={this.position_name} size="10" style={{width: '250px', height: '200px'}}>
                                        {positionList[this.state.chosenPositionSubCategory]
                                        ? positionList[this.state.chosenPositionSubCategory]
                                            .map((item) => <option key={item.id} value={item.id}>{item.name}</option>)
                                        : ''}
                                    </select>
                                    </div>
                                    <div className="list_icons_vertical">
                                        {this.loadOrderIcons({
                                            'upAction': () => { this.reorderPosition(this.position_name.current.value, 'up') },
                                            'downAction': () => { this.reorderPosition(this.position_name.current.value, 'down') },
                                            'editAction': () => {this.setState({selectedPosition: this.position_name.current.value}); this.toggleModal('load_pos'); this.toggleModal('save_pos');},
                                            'deleteAction': () => { this.deletePosition(this.position_name.current.value) },
                                        })}
                                    </div>
                                    <div style={{clear: 'both'}}></div>
                                    
                                    <div>
                                    <button onClick={this.loadPosition.bind(this)}>{strings.load}</button>&nbsp;
                                    <button onClick={this.toggleModal.bind(this, 'load_pos')}>{strings.cancel}</button>
                                    </div>
                                </div>
                            </form>
                            </Modal>

                            <Modal
                            isOpen={this.state.modal.edit_categories}
                            onAfterOpen={this.afterOpenModal.bind(this, 'edit_categories')}
                            onRequestClose={this.toggleModal.bind(this, 'edit_categories')}
                            style={modalStyles}
                            >
                            <h2>{strings.editCategories}</h2>

                            <div>
                                {positionCategoryList.map(item => {
                                    var name = item.parent !== '#root'
                                        ? '- ' + item.name
                                        : item.name;
                                    return (
                                        <div key={item.id}>
                                            <div style={{width: '250px', float: 'left'}}>
                                            {name}
                                            </div>
                                            <div className="list_icons">
                                                {this.loadOrderIcons({
                                                    'upAction': this.reorderCategory.bind(this, item.id, 'up'),
                                                    'downAction': this.reorderCategory.bind(this, item.id, 'down'),
                                                    'editAction': () => {this.setState({selectedCategory: item}); this.toggleModal('edit_category')},
                                                    'deleteAction': this.deleteCategory.bind(this, item),
                                                    'editTitle': strings.editCategory,
                                                    'deleteTitle': strings.deleteCategory,
                                                })}
                                            </div>
                                        </div>
                                    )
                                })}
                                <div>
                                <button onClick={this.toggleModal.bind(this, 'edit_categories')}>{strings.close}</button>
                                </div>
                            </div>
                            </Modal>

                            <Modal
                            isOpen={this.state.modal.edit_category}
                            onAfterOpen={this.afterOpenModal.bind(this, 'edit_category')}
                            onRequestClose={this.toggleModal.bind(this, 'edit_category')}
                            style={modalStyles}
                            >
                            <h2>{strings.editCategory}</h2>
                            <form>
                                    <label htmlFor="categoryName">{strings.categoryName}</label>
                                    <input ref={this.category_name} id="categoryName" type="text" name="category_name" defaultValue={this.state.selectedCategory ? this.state.selectedCategory.name : ''} />
                                    <label htmlFor="categoryParent">{strings.categoryParent}</label>
                                    <select
                                        id="categoryParent"
                                        defaultValue={this.state.selectedCategory ? this.state.selectedCategory.parent : ''}
                                        ref={this.category_parent}
                                    >
                                            <option value="#root">--- {strings.rootCategory} ---</option>
                                            {
                                                positionCategoryList.filter(item => item.parent === '#root')
                                                .map(item => <option key={item.id} value={item.id}>{item.name}</option>)
                                            }
                                    </select>
                                    <div>
                                    <button onClick={this.saveCategory.bind(this, this.state.selectedCategory ? {id: this.state.selectedCategory.id, order: this.state.selectedCategory.order} : {})}>{strings.save}</button>&nbsp;
                                    <button onClick={this.toggleModal.bind(this, 'edit_category')}>{strings.cancel}</button>
                                    </div>
                            </form>
                            </Modal>

                            <Modal
                            isOpen={this.state.modal.add_category}
                            onAfterOpen={this.afterOpenModal.bind(this, 'add_category')}
                            onRequestClose={this.toggleModal.bind(this, 'add_category')}
                            style={modalStyles}
                            >
                            <h2>{strings.addCategory}</h2>
                            <div>{strings.categoryName}</div>
                            <form>
                                <input type="text" name="positionCategoryName" ref={this.category_name} />
                                <button onClick={this.saveCategory.bind(this, {parent: '#root'})}>{strings.save}</button>&nbsp;
                                <button onClick={this.toggleModal.bind(this, 'add_category')}>{strings.cancel}</button>
                            </form>
                            </Modal>

                            <Modal
                            isOpen={this.state.modal.add_subcategory}
                            onAfterOpen={this.afterOpenModal.bind(this, 'add_subcategory')}
                            onRequestClose={this.toggleModal.bind(this, 'add_subcategory')}
                            style={modalStyles}
                            >
                            <h2>{strings.addSubcategory}</h2>
                            <div style={{paddingBottom: '10px'}}>{strings.forMainCategory} <b>{positionCategoryObj[this.state.chosenPositionCategory] ? positionCategoryObj[this.state.chosenPositionCategory].name : ''}</b></div>
                            <div>{strings.subcategoryName}</div>
                            <form>
                                <input type="text" name="positionCategoryName" ref={this.category_name} />
                                <button onClick={this.saveCategory.bind(this, {parent: this.state.chosenPositionCategory})}>{strings.save}</button>&nbsp;
                                <button onClick={this.toggleModal.bind(this, 'add_subcategory')}>{strings.cancel}</button>
                            </form>
                            </Modal>

                            <Modal
                            isOpen={this.state.modal.export_all}
                            onAfterOpen={this.afterOpenModal.bind(this, 'export_all')}
                            onRequestClose={this.toggleModal.bind(this, 'export_all')}
                            style={modalStyles}
                            >
                            <h2>{strings.exportPositions}</h2>
                            <form>
                                <label htmlFor="categorySelect">{strings.category}</label>
                                <div className="row">
                                    {categorySelectHtml}
                                </div>
                                <div style={!this.state.chosenPositionCategory ? {display: 'none'}: {}}>
                                <label htmlFor="subcategorySelect">{strings.subcategory}</label>
                                <div className="row">
                                    {subCategorySelectHtml}    
                                </div>
                                </div>

                                <div style={!this.state.chosenPositionSubCategory ? {display: 'none'}: {}}>
                                    <div style={{float: 'left'}}>
                                        <label htmlFor="positionName">{strings.positions}</label>
                                        <select multiple={true} ref={this.exportable_positions} size="10" style={{width: '250px', height: '200px'}}>
                                            {!positionList[this.state.chosenPositionSubCategory]
                                            ? ''
                                            : positionList[this.state.chosenPositionSubCategory]
                                                .map((item) => <option selected key={item.id} value={item.id}>{item.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="list_icons_vertical">
                                        {this.loadOrderIcons({
                                            'upAction': () => { this.reorderPosition(this.exportable_positions.current.value, 'up') },
                                            'downAction': () => { this.reorderPosition(this.exportable_positions.current.value, 'down') },
                                            'editAction': () => {this.setState({selectedPosition: this.exportable_positions.current.value}); this.toggleModal('export_all'); this.toggleModal('save_pos');},
                                            'deleteAction': () => { this.deletePosition(this.exportable_positions.current.value) },
                                        })}
                                    </div>
                                    <div style={{clear: 'both'}}></div>

                                    <div style={{paddingBottom: '10px'}}>
                                        <div><b>{strings.layout}</b></div>
                                        <RadioGroup name="export_layout" selectedValue={this.state.exportLayout} onChange={(value) => this.setState({exportLayout: value})}>
                                            <Radio value="1x1" /> 1x1&nbsp;
                                            <Radio value="1x2" /> 1x2&nbsp;
                                            <Radio value="2x2" /> 2x2&nbsp;
                                            <Radio value="2x3" /> 2x3&nbsp;
                                        </RadioGroup>
                                    </div>
                                    
                                    <div>
                                        <button onClick={this.toggleModal.bind(this, 'export_board')}>{strings.exportSelected}</button>&nbsp;
                                        <button onClick={this.toggleModal.bind(this, 'export_all')}>{strings.cancel}</button>
                                    </div>
                                </div>

                            </form>
                            </Modal>
                        
                            <Modal
                            isOpen={this.state.modal.export_board}
                            onAfterOpen={this.afterOpenModal.bind(this, 'export_board')}
                            onRequestClose={this.toggleModal.bind(this, 'export_board')}
                            style={modalStyles}
                            >
                            <h2>{strings.exportBoard}</h2>
                            <form>
                                <div style={{paddingBottom: 10}}>
                                    <div><b>{strings.size}</b></div>
                                    <RadioGroup name="export_size" selectedValue={this.state.exportSize} onChange={(value) => this.setState({exportSize: value})}>
                                        {/*<Radio value="S" /> S<br />
                                        <Radio value="M" /> M<br />
                                        <Radio value="L" /> L<br />
                                        <Radio value="custom" /> {strings.customWidth}<br />*/}
                                        { /* hide other sizes, they won't work, we disabled image resizing because of image quality deteriorate */ }
                                        <Radio value="L" /> Eredeti<br />
                                    </RadioGroup>
                                    <div style={this.state.exportSize !== 'custom' ? {display: 'none'}: {}}>
                                        <input type="text" name="export_size_custom" value={this.state.exportSizeCustom} onChange={(event) => this.setState({exportSizeCustom: event.target.value})} />
                                    </div>
                                </div>
                                
                                <button onClick={this.state.modal.export_all ? this.exportBoardAll.bind(this) : this.exportBoard.bind(this, 'single')}>{strings.export}</button>&nbsp;
                                <button onClick={this.toggleModal.bind(this, 'export_board')}>{strings.cancel}</button>
                            </form>
                            </Modal>                            
                        </div>
                    </div>
                    <div id="settings" className="column settings_div" style={this.state.showSettings ? {} : {'width': '30px'}}>
                        <Settings
                            arrowStyle={this.state.arrowStyle}
                            availableBoardThemes={availableBoardThemes}
                            availableFontFamilys={availableFontFamilys}
                            availablePieceThemes={availablePieceThemes}
                            board={this.state.board}
                            currentPage={this.state.currentPage}
                            description={this.state.description}
                            defaultHeadlineText={defaultHeadlineText}
                            defaultTab={this.state.defaultTab}
                            defaultTabExtra={this.state.defaultTabExtra}
                            difficulty={this.state.difficulty}
                            exportFen={this.exportFen.bind(this)}
                            gamificationStates={gamificationStates}
                            headline={this.state.headline}
                            highlightStyle={this.state.highlightStyle}
                            indexStyle={this.state.indexStyle}
                            lang={this.state.language}
                            layerStyle={this.state.layerStyle}
                            newPosition={this.newPosition.bind(this)}
                            notation={this.state.notation}
                            showSettings={this.state.showSettings}
                            strings={strings}
                            toggleSettings={this.toggleSettings.bind(this)}
                            toggleModal={this.toggleModal.bind(this)}
                            updateState={this.updateState.bind(this)}
                            wallStyle={this.state.wallStyle}
                            whoCanWin={this.state.whoCanWin}
                            whoCanWinStates={whoCanWinStates}
                        />
                            <Modal
                            isOpen={this.state.modal.import_fen}
                            onAfterOpen={this.afterOpenModal.bind(this, 'import_fen')}
                            onRequestClose={this.toggleModal.bind(this, 'import_fen')}
                            style={modalStyles}
                            >
                            <h2>{strings.fenImport}</h2>
                            <div>{strings.insertFen}</div>
                            <form >
                                <input type="text" name="fen" ref={this.fen} />
                                <div>
                                <button onClick={this.importFen.bind(this)}>{strings.import}</button>&nbsp;
                                <button onClick={this.toggleModal.bind(this, 'import_fen')}>{strings.cancel}</button>
                                </div>
                            </form>
                            </Modal>
                        
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        )
    }

    componentDidMount() {
        var url = new URL(window.location.href);
        var settings = url.searchParams.get("settings");
        if (settings) {
            let state = JSON.parse(settings);
            this.setState(state);
        }
        strings.setLanguage(this.state.language);

        firebase.firestore().settings({timestampsInSnapshots: true});

        this.loadAccount();
        if (this.state.accountId) {
            this.loadCustomThemes();
            this.loadPositionCategories();
            this.loadPositions();
        }
    }

    componentDidUpdate() {
        if (this.state.showBoard) {
            localStorage.setItem(stateVariableName, JSON.stringify(this.state));
        }

//        strings.setLanguage(this.state.language);
        if (undoMode) {
            undoMode = false;
        } else if (this.state.rerender >= 2) {
            this.props.history.addStep(this.state);
        }
    }

    getLocalstorageState() {
        let state = {};
        if (localStorage.getItem(stateVariableName)) {
            state = JSON.parse(localStorage.getItem(stateVariableName));
            state.arrowMode = false;
            state.board.draggable = true;
            state.highLightMode = false;
            state.indexMode = false;
            state.multiAddPiece = false;
            state.wallMode = false;
            state.layerMode = false;
            state.rerender = 0;
            state.showBoard = false;
            state.localStorage = true;
        }
        return state;
    }

    clearLocalstorage() {
        if (localStorage.getItem(stateVariableName)) {
            localStorage.removeItem(stateVariableName)
        }
    }

    startPosition() {
        this.updatePosition(ChessUtils.fenToObj(INITIAL_FEN));
        this.setState({highlights: {}, arrows: [], walls: {}, layers: {}, indexes: {}});
    }

    clearBoard() {
        this.updatePosition({});
        this.setState({highlights: {}, arrows: [], walls: {}, layers: {}, indexes: {}});
    }

    flipBoard() {
        var board = this.state.board;
        board.orientation = board.orientation === 'white' ? 'black' : 'white';
        this.setState({board: board});
    }

    exportBoard(exportType, event) {
        if (event) {event.preventDefault();}
        if (!this.state.exportSize) {
            alert(strings.missingExportSize);
            return;
        }
        if (this.state.accountId !== '1' && this.state.exportLimit <= this.state.exportCount) {
            alert(strings.outOfCredit);
            return;
        }
        if (exportType === 'single') {
            originalBoard = document.getElementById('boardsContainer').childNodes[0];
        }

        var width, height, ratio;
        switch (this.state.exportSize) {
            case 'S':
                if (this.state.exportLayout === "2x2" | this.state.exportLayout === "2x3") {
                    width = 400;
                } else {
                    width = 200;
                }
                break;
            
            case 'M':
                if (this.state.exportLayout === "2x2" | this.state.exportLayout === "2x3") {
                    width = 600;
                } else {
                    width = 300;
                }
                break;

            case 'L':
                width = document.getElementById('boardsContainer').offsetWidth;
                break;
            
            case 'custom':
                width = this.state.exportSizeCustom;
                break;
            
            default:
                break;
        }

        ratio = width / document.getElementById('boardsContainer').offsetWidth;
        height = Math.round(document.getElementById('boardsContainer').offsetHeight * ratio);

        var loader;
        if (!document.getElementById('loading_icon')) {
            loader = document.createElement("div");
            loader.id = 'loading_icon';
            loader.className = 'loader loader-' + this.state.language;    
            document.body.appendChild(loader);
        } else {
            loader = document.getElementById('loading_icon');
        }

        // Printing bottom back line fix
        document.getElementById('boardsContainer').style.height = (height+7) + 'px'

        $('.spare-pieces-7492f').hide();
        $('.actionButtons').hide();
        $('.settings_div').hide();
        $('.watermark').css('visibility', 'hidden');

        domtoimage.toJpeg(document.getElementById('boardsContainer'), { quality: 1 })
        .then((dataUrl) => {
            $('.spare-pieces-7492f').show();
            $('.actionButtons').show();
            $('.settings_div').show();
            $('.watermark').css('visibility', '');
            document.getElementById('boardsContainer').style.height = 'auto';

            if (true) {
                var link = document.createElement('a');
                var timestamp = + new Date();
                link.download = 'chessboard_'+timestamp+'.jpeg';
                link.href = dataUrl;
                link.click();    
            }

            this.decreaseCredit();
            document.getElementById('boardsContainer').innerHTML = '';
            document.getElementById('boardsContainer').appendChild(originalBoard);
            originalBoard = false;
                
            if (exportType === 'multi') {
                setTimeout(() => { this.exportNextPage() }, 1000);
            } else {
                this.setState({currentPage: 1});
                loader.parentNode.removeChild(loader);
            } 
        })
        .catch((err) => {
            console.log('Error during exporting');
            console.log(err);
        });
    }

    exportPrintableBoards(printPagePositions, currentPage) {
        var settings = JSON.parse(printPagePositions[0].setting);
        settings.currentPage = currentPage;

        originalBoard = document.getElementById('boardsContainer').childNodes[0];

        this.loadPositionSetting(settings, () => {
            var node = document.getElementById('boardsContainer').childNodes[0].cloneNode(true);
            printableBoards.push(node);
            printPagePositions.shift();
            if (printPagePositions.length) {
                this.exportPrintableBoards(printPagePositions, ++currentPage);
            } else {
                var currentNode = document.getElementById('boardsContainer').childNodes[0];
                document.getElementById('boardsContainer').removeChild(currentNode);
                printableBoards.forEach(node => {
                    document.getElementById('boardsContainer').appendChild(node);
                });
                if (this.state.exportLayout === "2x2" || this.state.exportLayout === "2x3") {
                    if (this.state.notation.type !== 'none') {
                        document.getElementById('boardsContainer').style.width = '900px';
                    } else {
                        document.getElementById('boardsContainer').style.width = '870px';
                    }
                    document.getElementById('boardsContainer').style.display = 'flex';
                    document.getElementById('boardsContainer').style.flexWrap = 'wrap';
                } else {
                    if (this.state.notation.type !== 'none') {
                        document.getElementById('boardsContainer').style.width = '450px';
                    } else {
                        document.getElementById('boardsContainer').style.width = '435px';
                    }
                    document.getElementById('boardsContainer').style.display = 'block';
                }

                //this.toggleModal('export_board');
                setTimeout(() => { this.exportBoard('multi') }, 1000);
                this.setState({currentPage: ++currentPage});
            }
        });
    }
    exportBoardAll(event) {
        event.preventDefault();
        printablePositions = [];
        Array.from(this.exportable_positions.current.options)
            .filter(option => option.selected)
            .map(option => printablePositions.push(positionObj[option.value]));
        
        if (
            printablePositions.length === 0
            || !this.state.exportLayout
        ) {
            alert(strings.missingPositionOrLayout);
            return;
        }
        if (!this.state.exportSize) {
            alert(strings.missingExportSize);
            return;
        }
        if (this.state.accountId !== '1' && this.state.exportLimit <= this.state.exportCount) {
            alert(strings.outOfCredit);
            return;
        }

        this.exportNextPage();
    }

    exportNextPage() {
        if (!printablePositions.length) {
            this.setState({currentPage: 1});
            var loader = document.getElementById('loading_icon');
            loader.parentNode.removeChild(loader);

            $('.spare-pieces-7492f').show();
            $('.actionButtons').show();
            $('.settings_div').show();
            $('.watermark').css('visibility', '');

            return;
        }
        var printPagePositions;
        switch(this.state.exportLayout) {
            case '1x1':
                printPagePositions = printablePositions.slice(0, 1);
                printablePositions.splice(0, 1);
                break;

            case '1x2':
                printPagePositions = printablePositions.slice(0, 2);
                printablePositions.splice(0, 2);
                break;
                
            case '2x2':
                printPagePositions = printablePositions.slice(0, 4);
                printablePositions.splice(0, 4);
                break;
                
            case '2x3':
                printPagePositions = printablePositions.slice(0, 6);
                printablePositions.splice(0, 6);
                break;
            
            default:
                break;
        }

        $('.spare-pieces-7492f').hide();
        $('.actionButtons').hide();
        $('.settings_div').hide();

        printableBoards = [];
        this.exportPrintableBoards(printPagePositions, this.state.currentPage);
    }

    exportFen(event) {
        event.preventDefault();

        var fen = [
            ChessUtils.objToFen(this.state.board.position),
            this.state.whoCanWin === 1 ? 'b' : 'w',
            '-',
            '-',
            0,
            1
        ].join(' ');

        this.copyToClipboard(fen);
        NotificationManager.success('', strings.exportFenSuccess);        
    }

    importFen(event) {
        event.preventDefault();

        let [position, starter] = this.fen.current.value.split(' ');
        var newState = this.state;
        newState.board.position = ChessUtils.fenToObj(position);
        newState.modal = {};
        newState.whoCanWin = starter === 'b'
            ? 1
            : 0;

        this.setState(newState);
    }

    savePosition() {
        if (!this.position_name.current.value) {
            alert(strings.missingPositionName)
            return;
        }

        var positionName = this.position_name.current.value;
        var positionSettings = {
            arrows: this.state.arrows,
            arrowStyle: this.state.arrowStyle,
            board: {
                position: this.state.board.position,
            },
            description: this.state.description,
            difficulty: this.state.difficulty,
            headline: this.state.headline,
            highlights: this.state.highlights,
            highlightStyle: this.state.highlightStyle,
            indexes: this.state.indexes,
            indexStyle: this.state.indexStyle,
            layers: this.state.layers,
            layerStyle: this.state.layerStyle,
            walls: this.state.walls,
            wallStyle: this.state.wallStyle,
            whoCanWin: this.state.whoCanWin,
        }
        var id, orderNum = 1;

        if (this.state.selectedPosition) { // Edit position
            id = this.state.selectedPosition;
            firebase.firestore().collection('positions').doc(id).set({
                account_id: this.state.accountId,
                category: this.state.chosenPositionSubCategory,
                name: positionName,
            }, { merge: true });
        } else { // New position
            //id = new Date().valueOf().toString();
            if (positionList[this.state.chosenPositionSubCategory]) {
                var currentList = positionList[this.state.chosenPositionSubCategory];
                orderNum = currentList[currentList.length-1].order + 1;
            }
            
            firebase.firestore().collection('positions').add({
                account_id: this.state.accountId,
                category: this.state.chosenPositionSubCategory,
                name: positionName,
                order: orderNum,
                setting: JSON.stringify(positionSettings),
            });
        }

        this.toggleModal('save_pos');
        NotificationManager.success('', strings.savePositionSuccess.replace('[POSITION_NAME]', positionName));
        this.loadPositions();
    }

    loadPosition(event) {
        event.preventDefault();
        //return false;
        if (!this.position_name.current.selectedOptions[0]) {
            alert(strings.choosePosition+'!')
            return;
        }

        // TODO - elmenteni statebe aktuális pozíció nevét és valahol felül megjeleníteni
        var positionId = this.position_name.current.selectedOptions[0].value;
        var item = positionList[this.state.chosenPositionSubCategory].find(element => { return element.id === positionId});

        this.loadPositionSetting(JSON.parse(item.setting));
        NotificationManager.success('', strings.loadPositionSuccess.replace('[POSITION_NAME]', item.name));
    }

    loadPositionSetting(positionSettings, callback = false) {
        var newState = JSON.parse(JSON.stringify(this.state));

        newState.modal = {};
        newState.arrows = [];
        newState.highlights = [];
        newState.indexes = [];
        newState.layers = [];
        newState.walls = [];

        newState.board.position = positionSettings.board.position;
        Object.keys(positionSettings).forEach(key => {
            if (key !== 'board') {
                newState[key] = positionSettings[key];
            }
        })

        if (callback) {
            this.setState(newState, callback);
        } else {
            this.setState(newState);
        }
    }

    saveCategory(params = {}, event) {
        event.preventDefault();
        var id = params.id
            ? params.id
            : new Date().valueOf().toString();
        var parent = params.parent
            ? params.parent
            : this.category_parent.current.value;

        var orderNum;
        if (params.order) {
            orderNum = params.order;
        } else if (positionCategoriesByParent[parent]) {
            var currentList = positionCategoriesByParent[parent];
            orderNum = currentList[currentList.length-1].order + 1;
        } else {
            orderNum = 1;
        }

        firebase.firestore().collection('position_categories').doc(id).set({
            account_id: this.state.accountId,
            id: id,
            name: this.category_name.current.value,
            order: orderNum,
            parent: parent,
        }, { merge: true });
        if (params.id) {
            this.toggleModal('edit_category');
        } else if (params.parent !== '#root') {
            this.toggleModal('add_subcategory');
            this.setState({chosenPositionSubCategory: id});
        } else {
            this.toggleModal('add_category');
            this.setState({chosenPositionCategory: id});
        }
        this.loadPositionCategories(true);
    }

    deleteCategory(item) {
        if (!window.confirm(strings.confirmDeleteCategory.replace('[CATEGORY_NAME]', item.name))) {
            return;
        }
        if (positionCategoriesByParent[item.id]) {
            window.alert(strings.cannotDeleteMainCategoryError);
            return;            
        }
        if (positionList[item.id]) {
            window.alert(strings.cannotDeleteNonEmptyCategoryError);
            return;
        }
        
        firebase.firestore().collection('position_categories').doc(item.id).delete().then(() => {
            console.log("Document successfully deleted!");
            this.loadPositionCategories(true);
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
    }
    
    deletePosition(id) {
        var item = positionObj[id];
        if (!window.confirm(strings.confirmDeletePosition.replace('[POSITION_NAME]', item.name))) {
            return;
        }

        this.setState({selectedPosition: ''});
        firebase.firestore().collection('positions').doc(item.id).delete().then(() => {
            console.log("Document successfully deleted!");
            NotificationManager.warning('', strings.deletePositionSuccess.replace('[POSITION_NAME]', item.name));
            this.loadPositions();
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });

    }

    reorderCategory(id, direction) {
        var origObj = JSON.parse(JSON.stringify(positionCategoryObj));
        var categoryItem = positionCategoryObj[id];
        var siblingCategories = positionCategoriesByParent[categoryItem.parent];
        var orderInList = siblingCategories.indexOf(categoryItem);
        if (direction === 'up') {
            if (orderInList === 0 || siblingCategories.length === 1) {
                return;
            }
        } else {
            if (orderInList === siblingCategories.length-1) {
                return;
            }
        }
        if (direction === 'up') {
            this.swapArrayItems(siblingCategories, orderInList, orderInList-1);
        } else {
            this.swapArrayItems(siblingCategories, orderInList, orderInList+1);
        }
        this.reorderArrayItems(siblingCategories);

        var batch = firebase.firestore().batch();
        siblingCategories.forEach(item => {
            if (JSON.stringify(item) === JSON.stringify(origObj[item.id])) {
                return;
            }
            var docRef = firebase.firestore().collection('position_categories').doc(item.id);
            batch.set(docRef, item, { merge: true });
        });
        batch.commit().then(() => {
            this.loadPositionCategories(true);
        });
        // TODO - gyorsítani a megjelenést, state-ben átírjuk, és majd utólag dbben. Nagyon nehéz megoldani, gyerekkategóriákat is át kell rendezni
        //this.setState({positionCategoryList: positionCategoryList});
    }

    reorderPosition(id, direction) {
        var origObj = JSON.parse(JSON.stringify(positionObj));
        var positionItem = positionObj[id];
        var siblingPositions = positionList[positionItem.category];
        var orderInList = siblingPositions.indexOf(positionItem);
        if (direction === 'up') {
            if (orderInList === 0 || siblingPositions.length === 1) {
                return;
            }
        } else {
            if (orderInList === siblingPositions.length-1) {
                return;
            }
        }
        if (direction === 'up') {
            this.swapArrayItems(siblingPositions, orderInList, orderInList-1);
        } else {
            this.swapArrayItems(siblingPositions, orderInList, orderInList+1);
        }
        this.reorderArrayItems(siblingPositions);

        var batch = firebase.firestore().batch();
        siblingPositions.forEach(item => {
            if (JSON.stringify(item) === JSON.stringify(origObj[item.id])) {
                return;
            }
            var docRef = firebase.firestore().collection('positions').doc(item.id);
            batch.set(docRef, item, { merge: true });
        });
        batch.commit().then(() => {
            this.loadPositions();
        });

        this.setState({rerender: this.state.rerender+1});
    }

    saveTheme() {
        //Tábla design, Koordinata, figura design
        var themeSettings = {
            board: {
                pieceTheme: this.state.board.pieceTheme,
                pieceSize: this.state.board.pieceSize,
                boardPattern: this.state.board.boardPattern,
                boardTheme: this.state.board.boardTheme,
                boardColors: this.state.board.boardColors,
            },
            notation: {
                color: this.state.notation.color,
                fontFamily: this.state.notation.fontFamily,
                fontSize: this.state.notation.fontSize,
                fontStyle: this.state.notation.fontStyle,
                type: this.state.notation.type,
            },
        }

        firebase.firestore().collection('themes').add({
            account_id: this.state.accountId,
            name: this.state.customThemeName,
            setting: JSON.stringify(themeSettings),
        });
        NotificationManager.success('', strings.saveThemeSuccess.replace('[THEME_NAME]', this.state.customThemeName));
        this.setState({customThemeName: '', modal: {}});
        this.loadCustomThemes();
    }
    loadTheme() {
        var themeSettings = JSON.parse(customThemeList[this.state.chosenCustomTheme]);
        var newState = this.state;
        newState.board = Object.assign(newState.board, themeSettings.board);
        newState.notation = Object.assign(newState.notation, themeSettings.notation);
        newState.chosenCustomTheme = '';
        newState.modal = {};

        NotificationManager.success('', strings.loadThemeSuccess.replace('[THEME_NAME]', this.state.customThemeName));
        this.setState(newState);
    }
    highlightModeOn(type) {
        this.cancelFeature();
        var board = this.state.board;
        board.draggable = false;
        this.setState({board: board, highLightMode: type});
        document.getElementById('board_inner').style.cursor = "cell";
    }
    highLightCell(square) {
        var highlights = this.state.highlights;
        if (highlights[square] === this.state.highLightMode) {
            delete highlights[square];
        } else {
            highlights[square] = this.state.highLightMode;
        }
        this.setState({highlights: highlights});
    }
    addWall(square) {
        var walls = this.state.walls;
        if (walls[square.wall] === this.state.wallMode) {
            delete walls[square.wall];
        } else {
            walls[square.wall] = this.state.wallMode;
        }
        this.setState({walls: walls});
    }
    addLayer(square) {
        var layers = this.state.layers;
        if (layers[square] === this.state.layerMode) {
            delete layers[square];
        } else {
            layers[square] = this.state.layerMode;
        }
        this.setState({layers: layers});
    }
    addIndex(square) {
        var indexes = this.state.indexes;
        if (!indexes[square.cell]) {
            indexes[square.cell] = {};
        }
        if (indexes[square.cell][square.position] && indexes[square.cell][square.position].mode === this.state.indexMode) {
            delete indexes[square.cell];
        } else {
            var index = prompt(strings.addIndexPrompt);
            if (index === null) { return; }
            indexes[square.cell][square.position] = {
                mode: this.state.indexMode,
                index: index,
            }
        }
        this.setState({indexes: indexes});
    }
    
    arrowModeOn(type) {
        this.cancelFeature();
        var board = this.state.board;
        board.draggable = false;
        this.setState({board: board, arrowMode: type});
        document.getElementById('board_inner').style.cursor = "crosshair";
    }
    wallModeOn(type) {
        this.cancelFeature();
        var board = this.state.board;
        board.draggable = false;
        this.setState({board: board, wallMode: type});
        document.getElementById('board_inner').style.cursor = "cell";
    }
    layerModeOn(type) {
        this.cancelFeature();
        var board = this.state.board;
        board.draggable = false;
        this.setState({board: board, layerMode: type});
        document.getElementById('board_inner').style.cursor = "cell";
    }
    indexModeOn(type) {
        this.cancelFeature();
        var board = this.state.board;
        board.draggable = false;
        this.setState({board: board, indexMode: type});
        document.getElementById('board_inner').style.cursor = "cell";
    }

    onMouseoverSquare(square, piece) {
        if (this.state.highLightMode || this.state.arrowMode || this.state.layerMode) {
            var squareEl = jQuery('#board .square-' + square + ' .square_bg');
            squareEl.addClass('highlight1-32417');
        }
    }

    onMouseoutSquare(square, piece) {
        if (this.state.highLightMode || this.state.arrowMode || this.state.layerMode) {
            var squareEl = jQuery('#board .square-' + square + ' .square_bg');
            squareEl.removeClass('highlight1-32417');
        }
    }
    onMouseDownSquare(square, piece) {
        if (this.state.arrowMode) {
            var currentArrow = {};
            currentArrow.start = square;
            this.setState({currentArrow: currentArrow});
        }
    }
    onMouseUpSquare(square, piece) {
        if (this.state.arrowMode) {
            var state = this.state;
            state.currentArrow.end = square;
            if (state.currentArrow.start !== state.currentArrow.end) {
                state.arrows.push({start: state.currentArrow.start, end: state.currentArrow.end, type: state.arrowMode});
                this.setState(state);
            }
        }
    }

    onClickSquare(square) {
        if (this.state.highLightMode) {
            this.highLightCell(square.cell);    
        }
        if (this.state.multiAddPiece) {
            var position = this.state.board.position;
            if (position[square.cell] !== this.state.multiAddPiece.figure) {
                position[square.cell] = this.state.multiAddPiece.figure;
            } else {
                delete position[square.cell];
            }
            this.updatePosition(position);
        }
        if (this.state.wallMode) {
            this.addWall(square);
        }
        if (this.state.layerMode) {
            this.addLayer(square.cell);
        }
        if (this.state.indexMode) {
            this.addIndex(square);
        }
    }

    updatePosition(position) {
        var board = this.state.board;
        board.position = position;
        this.setState({board: board});
    }

    updateState(key, value) {
        var state = this.state;
        state[key] = value;
        this.setState(state);
    }

    enableMultiAddMode(piece) {
        this.cancelFeature();
        this.setState({multiAddPiece: piece});
        document.getElementById('board_inner').style.cursor = "cell";
        document.getElementById('board_inner').addEventListener("mousemove", this.showSmallPiece);
        document.getElementById('board_inner').addEventListener("mouseout", this.hideCursorImage);
    }

    showSmallPiece(e) {
        document.getElementById('cursor_image').style.display = 'block';
        document.getElementById('cursor_image').style.left = (e.pageX-42)+'px';
        document.getElementById('cursor_image').style.top = (e.pageY+4)+'px';
    }

    hideCursorImage(e) {
        if (document.getElementById('cursor_image')) {
            document.getElementById('cursor_image').style.display = 'none';
        }
    }

    onMouseMoveOverBoard() { }

    cancelFeature() {
        var board = this.state.board;
        board.draggable = true;
        this.setState({board: board, highLightMode: false, arrowMode: false, multiAddPiece: false, wallMode: false, layerMode: false, indexMode: false});
        document.getElementById('board_inner').style.cursor = "auto";
        $('.square-55d63').removeClass('highlight1-32417');
        $('.square-55d63').css('z-index', '');
        $('.square-55d63').removeClass('show-border-top show-border-bottom show-border-left show-border-right');
        if ($('.square-index-test')) {
            $('.square-index-test').remove();
        }
        this.cancelMultiAddMode();
    }

    cancelMultiAddMode() {
        document.getElementById('board_inner').removeEventListener("mousemove", this.showSmallPiece);
        document.getElementById('board_inner').removeEventListener("mouseout", this.hideCursorImage);
    }

    toggleModal(type, event) {
        if (event) event.preventDefault();
        var modal = this.state.modal;
        modal[type] = !modal[type];
        this.setState({modal: modal});
    }
    
    afterOpenModal(type) { }
    
    loadAccount(e) {
        if (e) e.preventDefault();
        var accountId = this.getAccountId();
        if (!accountId) {
            if (this.state.accountId) {
                window.location.href = '/' + this.state.accountId;
                return;
            }
            return;
        }
        var userId = this.state.userId;
        if (!userId) {
            return;
        }
        if (!this.state.password) return;
        firebase.firestore().collection('accounts').doc(accountId).get().then((acc) => {
            if (!acc.id) return;
            var accData = acc.data();
            firebase.firestore().collection('users').where('account_id', '==', accountId).where('user_id', '==', userId).get().then((snapshot) => {
                if (snapshot.empty) {
                    if (e) NotificationManager.warning('', strings.invalidLogin);
                    this.setState({showBoard: false});
                } else {
                    var data = snapshot.docs[0].data();
                    if (data.password === md5(this.state.password)) {
                        if (e) NotificationManager.success('', strings.loginSuccess);
                        this.setState({showBoard: true, exportLimit: accData.export_limit, exportCount: (accData.export_count ? accData.export_count : 0), watermark: accData.watermark});
                    } else {
                        if (e) NotificationManager.warning('', strings.invalidLogin);
                        this.setState({showBoard: false});
                    }
                }
            });
        })
        return false;
    }

    logOut(e) {
        if (e) e.preventDefault();
        this.clearLocalstorage();
        window.location.href = '';
    }

    loadCustomThemes() {
        firebase.firestore().collection('themes').where('account_id', '==', this.state.accountId).get().then((querySnapshot) => {
            querySnapshot.forEach(function(doc) {
                customThemeList[doc.data().name] = doc.data().setting;
            });
        });
    }

    loadPositionCategories() {
        firebase.firestore().collection('position_categories').where('account_id', '==', this.state.accountId).orderBy("parent", "asc").orderBy("order", "asc").get().then((querySnapshot) => {
            positionCategoriesByParent = {};
            positionCategoryObj = {};
            positionCategoryList = [];
            querySnapshot.forEach(function(doc) {
                var data = Object.assign(doc.data(), {id: doc.id});
                positionCategoryObj[doc.id] = data;
                if (!positionCategoriesByParent[data.parent]) {
                    positionCategoriesByParent[data.parent] = [];
                }
                positionCategoriesByParent[data.parent].push(data);
            });

            positionCategoriesByParent['#root'].forEach((item) => {
                positionCategoryList.push(item);
                if (positionCategoriesByParent[item.id]) {
                    positionCategoriesByParent[item.id].forEach((cItem) => {
                        positionCategoryList.push(cItem);
                    })
                }
            });
            this.setState({rerender: this.state.rerender+1});
        });
    }

    loadPositions() {
        firebase.firestore().collection('positions').where('account_id', '==', this.state.accountId).orderBy("category", "asc").orderBy("order", "asc").get().then((querySnapshot) => {
            positionList = {};
            positionObj = {};
            querySnapshot.forEach(function(doc) {
                var data = Object.assign(doc.data(), {id: doc.id});
                if (!positionList[data.category]) {
                    positionList[data.category] = [];
                }
                positionList[data.category].push(data);
                positionObj[doc.id] = data;
            });
            this.setState({rerender: this.state.rerender+1});
        });
    }

    removeArrow(id) {
        var arrows = this.state.arrows;
        arrows.splice(id, 1);
        this.setState({arrows: arrows});
    }

    shareSettings() {
        var strJSON = encodeURIComponent(JSON.stringify(this.state));
        console.log(strJSON);
        this.copyToClipboard(window.location.origin + '?settings=' + strJSON);
        NotificationManager.success('', strings.settingsCopiedSuccess);
    }

    newPosition() {
        var newState = this.state;
        newState.description = {text: "", gamification: false};
        newState.headline.text = defaultHeadlineText;
        newState.whoCanWin = 0;
        newState.difficulty = 'easy';
        this.setState(newState);
        this.clearBoard();
    }

    copyToClipboard(str) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    swapArrayItems(array, i, j) {
        var tmp = array[j];
        array[j] = array[i];
        array[i] = tmp;
    }

    reorderArrayItems(array) {
        array.forEach((item, index) => {
            item.order = index+1;
        });
    }
    
    undoHistory() {
        var oldState = this.props.history.getUndoState();
        if (oldState) {
            this.setState(oldState);
            undoMode = true;
            this.props.history.undo();
        }
    }

    redoHistory() {
        var oldState = this.props.history.getRedoState();
        if (oldState) {
            undoMode = true;
            this.setState(oldState);
            this.props.history.redo();
        }
    }

    changeLanguage(selectedOption) {
        strings.setLanguage(selectedOption.value);
        this.setState({language: selectedOption.value});
    }

    getExtra(id) {
        var colors;
        var ids = [
            "",
            id + '1',
            id + '2',
            id + '3',
        ]
        var titles = [
            "",
            strings[id] + ' 1',
            strings[id] + ' 2',
            strings[id] + ' 3',
        ]
        var image = "/chessboardjs/img/icons/" + id + "-transparent.svg#Capa_1"
        var method = id + 'ModeOn';
        switch (id) {
            case 'arrow':
                colors = [
                    "",
                    this.state.arrowStyle.arrow1.lineColor,
                    this.state.arrowStyle.arrow2.lineColor,
                    this.state.arrowStyle.arrow3.lineColor,
                ]
                break;
            case 'layer':
                colors = [
                    "",
                    this.state.layerStyle.layer1.backgroundColor,
                    this.state.layerStyle.layer2.backgroundColor,
                    this.state.layerStyle.layer3.backgroundColor,
                ]
                break;
            case 'highlight':
            case 'wall':
            case 'index':
            default:
                colors = [
                    "",
                    this.state[id+'Style'][id+'1'].color,
                    this.state[id+'Style'][id+'2'].color,
                    this.state[id+'Style'][id+'3'].color,
                ]
                break;
        }
        return (
            <tr>
                <td title={titles[1]}>
                    <svg style={{fill: colors[1]}} onClick={this[method].bind(this, ids[1])}>
                        <use href={image}></use>
                    </svg>
                </td>
                <td title={titles[2]}>
                    <svg style={{fill: colors[2]}} onClick={this[method].bind(this, ids[2])}>
                        <use href={image}></use>
                    </svg>
                </td>
                <td title={titles[3]}>
                    <svg style={{fill: colors[3]}} onClick={this[method].bind(this, ids[3])}>
                        <use href={image}></use>
                    </svg>
                </td>
            </tr>
        )
    }

    loadOrderIcons(options) {
        let editTitle = options.editTitle ? options.editTitle : strings.editPosition;
        let deleteTitle = options.deleteTitle ? options.deleteTitle : strings.deletePosition;
        return (
            <div>
            <img alt={strings.moveUp} title={strings.moveUp} src="/chessboardjs/img/icons/up-arrow.svg" onClick={options.upAction} />
            <img alt={strings.moveDown} title={strings.moveDown} src="/chessboardjs/img/icons/down-arrow.svg" onClick={options.downAction} />
            <img alt={editTitle} title={editTitle} src="/chessboardjs/img/icons/edit-icon.svg" onClick={options.editAction} />
            <img alt={deleteTitle} title={deleteTitle} src="/chessboardjs/img/icons/trash-icon.svg" onClick={options.deleteAction} />
            </div>
        );
    }

    getAccountId() {
        return this.props.location.pathname.slice(1);
    }

    decreaseCredit() {
        firebase.firestore().collection('accounts').doc(this.state.accountId).get().then((doc) => {
            var exportCount = doc.data().export_count + 1;
            doc.ref.update({
                export_count: exportCount,
            });
            this.setState({exportCount: exportCount});
        });
    }

    toggleSettings() {
        this.setState({showSettings: !this.state.showSettings});
    }

    previewIndex(square, squareLocation) {
        var squareEl = document.querySelector('#board .square-' + square);
        let squareIndexId = 'square-index-test-' + square;
        $('.square-index-test').remove();

        let squareIndexEl;
        squareIndexEl = document.createElement('div');
        squareIndexEl.id = squareIndexId;
        squareIndexEl.className = 'square-index-test';
        squareEl.appendChild(squareIndexEl);
        
        if (squareLocation.bottom) {
          squareIndexEl.style.top = '50%';
        } else {
          squareIndexEl.style.top = 0;
        }
        if (squareLocation.right) {
          squareIndexEl.style.left = '50%';
        } else {
          squareIndexEl.style.left = 0;
        }
    }

    previewWall(square, nearestBorder) {
        $('.show-border-top').removeClass('show-border-top');
        $('.show-border-bottom').removeClass('show-border-bottom');
        $('.show-border-left').removeClass('show-border-left');
        $('.show-border-right').removeClass('show-border-right');

        var squareEl = document.querySelector('#board .square-' + square);
        squareEl.classList.add('show-border-'+nearestBorder);
    }

    dblClickOnSquare(square) {
        var squareEl = $('#board .square-' + square);

        if (squareEl.find('.cellLayer').length) {
            this.addLayer(square);
        }
    }
}



// WEBPACK FOOTER //
// ./src/Board.js